// extracted by mini-css-extract-plugin
export var cardSelected = "_fl-2";
export var image = "_fl-1";
export var table = "_fl-0";